// ============================================================================
// AdminLocationsPanel — top-level Locations library section.
// ============================================================================
// Wraps LocationManageModal in inline mode.
// ============================================================================

import { useCallback, useEffect, useState } from 'react';
import { api, type Location } from '../api';
import { LocationManageModal } from './LocationManageModal';

interface Props {
  token: string;
}

export function AdminLocationsPanel({ token }: Props) {
  const [locations, setLocations] = useState<Location[]>([]);
  const [error, setError] = useState('');

  const refresh = useCallback(() => {
    api.locations()
      .then((d) => setLocations(d.locations))
      .catch((err) => setError(err?.message || 'Could not load locations.'));
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Locations</h1>
        <p className="text-sm text-gray-600 mt-0.5">
          Venues you commonly host events at. Saved locations auto-fill the
          event form, including address, venue details, and photos.
        </p>
      </div>

      {error && (
        <div className="bg-red-50 border border-red-200 text-red-700 rounded-md px-3 py-2 text-sm">
          {error}
        </div>
      )}

      <LocationManageModal
        open={true}
        inline={true}
        onClose={() => {}}
        token={token}
        locations={locations}
        onRefresh={refresh}
      />
    </div>
  );
}
